import type { Schemas } from '~/clients/api-client'
import client from '~/clients/api-client'

import { handleApiRequest } from '../shared/apiWrapper'

export type HubSpotContactOut = Schemas['HubSpotContactOut']

export const DEFAULT_SUPPORT_SUBMIT_ERROR_MESSAGE = 'Noe gikk galt. Prøv igjen eller kontakt support på e-post eller telefon.'

function getApiErrorDetail<Err>(error: Err | undefined): string | undefined {
    if (error && typeof error === 'object' && 'detail' in error && typeof error.detail === 'string') {
        return error.detail
    }
    return undefined
}

export function formatSupportApiError<Err>(response: Response, error?: Err): string {
    if (response.status === 409) {
        return getApiErrorDetail(error) ?? DEFAULT_SUPPORT_SUBMIT_ERROR_MESSAGE
    }
    return DEFAULT_SUPPORT_SUBMIT_ERROR_MESSAGE
}

export async function fetchSupportHubSpotContact(): Promise<HubSpotContactOut | null> {
    const data = await handleApiRequest({
        apiCall: () => client.getSupportHubSpotContact(),
    })

    return data ?? null
}
